
import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import PageLoader from "./components/PageLoader";
import Home from "./features/dashboard/components/Home";
import useAuthStore from "./store/authStore";
import authApi from "./api/authApi";
import { Toaster } from "react-hot-toast";

// Lazy-loaded pages for Code Splitting (Phần B.2)
const LandingPage = lazy(() => import("./features/public/LandingPage"));
const Auth = lazy(() => import("./features/auth/Auth"));
const CreateRepair = lazy(() => import("./features/repair/components/CreateRepair"));
const RepairList = lazy(() => import("./features/repair/components/RepairList"));
const RepairDetail = lazy(() => import("./features/repair/components/RepairDetail"));
const CustomerList = lazy(() => import("./features/customer/components/CustomerList"));
const InventoryList = lazy(() => import("./features/inventory/components/InventoryList"));
const UserList = lazy(() => import("./features/user/components/UserList"));
const Profile = lazy(() => import("./pages/Profile"));

const Settings = () => <div className="flex items-center justify-center h-full"><p className="text-slate-400">Cài đặt</p></div>;

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/auth" replace />;
  return children;
};

function App() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const updateUser = useAuthStore(state => state.updateUser);

  useEffect(() => {
    if (isAuthenticated) {
      // Đồng bộ thông tin profile và kiểm tra hiệu lực của HttpOnly Cookie khi reload
      authApi.getProfile()
        .then(res => {
          if (res?.data) {
            updateUser(res.data);
          }
        })
        .catch(() => {
          // Nếu cookie hết hạn, axiosClient interceptor bắt 401 sẽ tự động dọn store và điều hướng
        });
    }
  }, [isAuthenticated, updateUser]);

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<Auth />} />
          
          {/* Protected Admin Routes */}
          <Route element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route path="/dashboard" element={<Home />} />
            <Route path="/create" element={<CreateRepair />} />
            <Route path="/repairs" element={<RepairList />} />
            <Route path="/repairs/:id" element={<RepairDetail />} />
            <Route path="/customers" element={<CustomerList />} />
            <Route path="/inventory" element={<InventoryList />} />
            <Route path="/users" element={<UserList />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Catch-all redirect to public landing */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;

